import { useEffect, useState } from "react";
import CloseIcon from '../../../../animation/jobs/Cross icon.svg';
import dropicon from '../../../../animation/jobs/dropdown icon.svg';
import LocationIcon from '../../../../animation/jobs/location.svg';
import styles from "./JobCountBar.module.css";

function JobCountBar({ pagination, selectedFilters, updateResults }) {
  const [open, setOpen] = useState(false);
  const [location, setLocation] = useState("");
  const [showlocation, setShowlocation] = useState("India")

  useEffect(()=>{
    setLocation(selectedFilters.location);
    setShowlocation(selectedFilters.location || 'India')
  }, [selectedFilters])


  return (
    <div className={styles.jobCountBar}>
      <span>{pagination.count || 0} results</span>

      <div className={styles.locationWrapper}>
<button
  className={styles.locationButton}
  onClick={() => setOpen(!open)}
>
  <img src={LocationIcon} className={styles.locationIcon} />
  {showlocation}
<img src={dropicon} className="dropdown-icon" alt="Dropdown" />
</button>


        {open && (
          <div className={styles.locationCard}>
            <div className={styles.inputDiv}>
              <div className={styles.locationHeader}>
                <span>Location</span>
                <button
                  className={styles.closeButton}
                  onClick={() => setOpen(false)}
                >
                  <img src={CloseIcon} fontSize="Small"/>
                </button>
              </div>

              <input
                type="text"
                placeholder="city, state or country"
                className={styles.locationInput}
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
            </div>

            <div className={styles.buttonDiv}>
              <div className={styles.locationActions}>
                <button
                  className={styles.clearBtn}
                  onClick={() => {
                    const updated = { ...selectedFilters, location: '' };
                    updateResults(updated)
                  }}
                >
                  Clear
                </button>
                <button
                  className={styles.showBtn}
                  onClick={() => {
                    const updated = { ...selectedFilters, location };
                    updateResults(updated)
                    setOpen(false);
                  }}
                >
                  Show results
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default JobCountBar;
